<template>
  <div class="description" v-if="content || hasSlot">
    <template v-if="tooltip">
      <w-tooltip v-if="ishtmlContent">
        <template v-if="hasSlot">
          <slot />
        </template>
        <span v-else v-html="content" />
      </w-tooltip>
      <w-tooltip v-else :tooltip="content" />
    </template>

    <template v-else>
      <span class="description-content" v-if="ishtmlContent">
        <slot v-if="hasSlot" />
        <span v-else v-html="content" />
      </span>

      <span class="description-content" v-else>{{ content }}</span>
    </template>
  </div>
</template>

<script>
export default {
  name: 'w-description',
  props: {
    value: {
      type: String,
      required: false
    },
    model: {
      type: Object,
      required: false
    },
    tooltip: {
      type: Boolean,
      default: false
    },
    htmlContent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    content() {
      return this.value || (this.model ? this.model.$schema.description : null);
    },
    hasSlot() {
      return !!this.$slots.default;
    },
    ishtmlContent() {
      return this.htmlContent || this.hasSlot;
    }
  }
};
</script>

<style>
.description {
  display: block;
}
.description-content {
  color: gray;
}
</style>
